import { ReactNode, ChangeEvent, SyntheticEvent, MouseEvent } from 'react'

import { IconName } from './Icons/types'
import SVGIcon from './Icons/svgs/SVGIcon'
import ChevronDownIcon from './Icons/svgs/ChevronDownIcon'
import FullArrowDownIcon from './Icons/svgs/FullArrowDownIcon'

const getIconComponent = (name: string): ((props: { [key: string]: any }) => React.ReactElement) => {
  switch (name) {
    case 'full-arrow-down':
      return FullArrowDownIcon

    default:
      return ChevronDownIcon
  }
}

export function Select({
  children,
  className,
  disabled,
  iconColor,
  icon,
  innerClassName,
  isFullWidth,
  name,
  onChange,
  onFocus,
  onClick,
  value,
}: {
  children: ReactNode
  className?: string
  disabled?: boolean
  iconColor?: string
  icon?: IconName
  innerClassName?: string
  isFullWidth?: boolean
  name?: string
  onChange: (event: ChangeEvent<HTMLSelectElement>) => void
  onFocus?: (event: SyntheticEvent<HTMLSelectElement>) => void
  onClick?: (event: MouseEvent<HTMLElement>) => void
  value: string
}): React.ReactElement {
  return (
    <div className={`relative mx-auto p-2 inline-block rounded ${className} ${isFullWidth ? 'w-full' : ''}`}>
      <select
        className={`w-full pr-8 appearance-none lg:text-md bg-transparent cursor-pointer disabled:opacity-50 ${innerClassName}`}
        disabled={disabled}
        name={name}
        onChange={onChange}
        onClick={onClick}
        onFocus={onFocus}
        value={value}
      >
        {children}
      </select>
      <div className={'absolute inset-y-0 right-0 px-4 ' + 'flex items-center pointer-events-none'}>
        <SVGIcon icon={getIconComponent(icon ?? '')} pathClassName={iconColor ?? 'text-black'} size={16} />
      </div>
    </div>
  )
}
